/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from '@azure/msal-browser';

/**
 * Shared logger callback function for MSAL
 */
const createLoggerCallback = () => (level, message, containsPii) => {
  if (containsPii) {
    return;
  }
  switch (level) {
    case LogLevel.Error:
      console.error(message);
      return;
    case LogLevel.Info:
      console.info(message);
      return;
    case LogLevel.Verbose:
      console.debug(message);
      return;
    case LogLevel.Warning:
      console.warn(message);
    default:
  }
};

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

export const msalConfig = {
  auth: {
    clientId: process.env.GATSBY_MY_ACCOUNT_MSAL_AUTH_CLIENT_ID,
    authority: process.env.GATSBY_MY_ACCOUNT_MSAL_AUTH_AUTHORITY,
    redirectUri: process.env.GATSBY_MY_ACCOUNT_MSAL_AUTH_REDIRECT_URI,
    postLogoutRedirectUri: '/',
    navigateToLoginRequestUrl: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: createLoggerCallback(),
    },
  },
};

export const partnerMsalConfig = {
  auth: {
    clientId: process.env.GATSBY_MY_ACCOUNT_MSAL_PARTNER_CLIENT_ID,
    authority: process.env.GATSBY_MY_ACCOUNT_MSAL_PARTNER_AUTHORITY,
    redirectUri: process.env.GATSBY_MY_ACCOUNT_MSAL_PARTNER_REDIRECT_URI,
    postLogoutRedirectUri: '/',
    navigateToLoginRequestUrl: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: createLoggerCallback(),
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: [],
};

/**
 * An optional silentRequest object can be used to achieve silent SSO
 * between applications by providing a "login_hint" property.
 */
// export const silentRequest = {
//     scopes: ["openid", "profile"],
//     loginHint: "example@domain.net"
// };
